export enum Locale {
    English = 'en',
    Portuguese = 'pt',
}

export enum TeamGender {
    Men = 0,
    Women = 1,
}

export enum TeamAge {
    Senior = 0,
    Youth = 1,
}

export enum TeamType {
    Club = 1,
    National = 2,
    Fantasy = 3,
}

export enum Sport {
    Football = 1,
    Basketball = 2,
}

export enum LeagueAgeCategory {
    Senior = 1,
    Youth = 2,
    Kids = 3,
}

export enum leagueCategory {
    International = 1,
    DomesticLeague = 2,
    InternationalFriendly = 6,
    ClubFriendly = 8,
    DomesticCup = 10,
    ClubInternational = 11,
}

export enum LeagueLimitsCategory {
    Pro = 1,
    High = 2,
    Medium = 3,
    Low = 4,
    Micro = 5,
}

export enum LeagueGender {
    Men = 1,
    Women = 2,
}

export enum LeagueMarketCategory {
    MicroEff = 1,
    LowEff = 2,
    YouthEff = 3,
    KidEff = 4,
    IntEff = 5,
    CfriEff = 6,
    FanEff = 7,
    MedEff = 8,
    ProEff = 9,
}

export enum TimeAutoRefresh {
    Off = 0,
    FiveSeconds = 5,
    FifteenSeconds = 15,
    ThirtySeconds = 30,
    OneMinute = 60,
    FiveMinutes = 300,
}

export enum Platform {
    Tradeball = 1,
    Betbra = 2,
    Apostasnow = 3,
    Apostasbf = 4,
    Drinbet = 5,
    Bolsadeaposta = 6,
    Greenwin = 7,
    Betbox = 8,
    Fulltbet = 9,
    Verdinhabet = 10,
    Oddjusta = 11,
    Matchbook = 12,
    Oddrs = 13,
}

export enum Teamwhere {
    Home = 1,
    Away = 2,
    Draw = 3,
}

export enum Jollywhere {
    None = 0,
    Home = 1,
    Away = 2,
}

export enum EventPeriod {
    FullTime = 1,
    FirstHalf = 2,
}

export enum EventType {
    Live = 1,
    Pregame = 2,
}

export enum BetStatus {
    Running = 1,
    Waiting = 2,
    Settled = 3,
    Rejected = 6,
    Refunded = 13,
    Void = 51,
    Abnormal = 52,
}

export enum WL {
    W = 'W',
    HW = 'HW',
    L = 'L',
    HL = 'HL',
    P = 'P',
}

export enum TradingType {
    Bot = 1,
    BetOrder = 2,
}

export enum BetSelection {
    HandicapHome = 1,
    HandicapAway = 2,
    GoalOver = 3,
    GoalUnder = 4,
    OneXTwoHome = 5,
    OneXTwoDraw = 6,
    OneXTwoAway = 7,
    BtsYes = 8,
    BtsNo = 9,
    Dc1X = 10,
    Dc12 = 11,
    DcX2 = 12,
    Cs = 13,
    CornersHandicapHome = 14,
    CornersHandicapAway = 15,
    CornersGoalOver = 16,
    CornersGoalUnder = 17,
    GoalHomeOver = 18,
    GoalHomeUnder = 19,
    GoalAwayOver = 20,
    GoalAwayUnder = 21,
    DrawNoBetHome = 22,
    DrawNoBetAway = 23,
    MoneylineHome = 24,
    MoneylineAway = 25,
    SpreadHome = 26,
    SpreadAway = 27,
}

export enum MarketType {
    OneXTwo = 1,
    Handicap = 2,
    Goal = 3,
    Bts = 4,
    Dc = 5,
    Cs = 6,
    CornersHandicap = 7,
    CornersGoal = 8,
    GoalHome = 9,
    GoalAway = 10,
    DrawNoBet = 11,
    Moneyline = 12,
    Spread = 13,
}

export enum BetSelectionType {
    Handicap = 1,
    Goal = 2,
    OneXTwo = 3,
    Bts = 4,
    Dc = 5,
    Cs = 6,
    CornersHandicap = 7,
    CornersGoal = 8,
}

export enum MarketGroup {
    Regular = 1,
    Corners = 2,
}

export enum BetOrderStatus {
    Open = 1,
    Closed = 2,
    Closing = 3,
}

export enum BetOrderCloseReason {
    Normally = 1,
    ScoreChanged = 2,
    TimedOut = 3,
    InsufficientCredit = 4,
    GameFinished = 5,
    ManuallyClosed = 6,
    GameStarted = 7,
    RejectedBet = 8,
    AccountBlocked = 9,
}

export enum BetFailPlainError {
    BookmakerFailedToExecute = 1,
    OddsReduced = 2,
    HandicapChanged = 3,
    CreditLineError = 4,
    BookmakerError = 5,
    InsufficientCredit = 6,
}

export enum DeviceType {
    PC = 1,
    Mobile = 2,
}

export enum BotBetRepetition {
    OneBetPerEvent = 1,
    OneBetPerEventScore = 2,
}

export enum Bookmaker {
    Sbo = 1,
    Ibc = 3,
    Sing = 5,
    Pinna = 10,
    Isn = 11,
    Betfair = 17,
    Sportmonks = 18,
    Sharpbet = 19,
    Pinweb = 20,
    ThreeBet = 21,
    Matchbook = 22,
    Betdaq = 23,
}

export enum Line {
    Main = 1,
    Two = 2,
    Three = 3,
    Four = 4,
    Five = 5,
    All = 1000,
}

export enum Status {
    Active = 'active',
    Inactive = 'inactive',
}

export enum EventSituation {
    Draw = 1,
    NoDraw = 2,
    HomeLeading = 3,
    AwayLeading = 4,
    HomeLeadingBy1 = 5,
    AwayLeadingBy1 = 6,
    HomeLeadingBy2 = 7,
    AwayLeadingBy2 = 8,
    HomeLeadingBy3OrMore = 9,
    AwayLeadingBy3OrMore = 10,
    FavouriteLeading = 11,
    UnderdogLeading = 12,
    FavouriteLeadingBy1 = 13,
    UnderdogLeadingBy1 = 14,
    FavouriteLeadingBy2 = 15,
    UnderdogLeadingBy2 = 16,
    FavouriteLeadingBy3OrMore = 17,
    UnderdogLeadingBy3OrMore = 18,
}

export enum EventRedCards {
    NoRedCards = 1,
    Home1ManUp = 2,
    Home2MenUp = 3,
    Away1ManUp = 4,
    Away2MenUp = 5,
    BothTeamsDownTo10Men = 6,
}

export enum BotTeamSelection {
    Home = 1,
    Away = 2,
    Favourite = 3,
    Underdog = 4,
}

export enum BotFavoriteSide {
    Home = 1,
    Away = 2,
}

export enum Currency {
    Euro = 1,
    Gbp = 2,
    Yen = 3,
    Brl = 4,
    Usd = 5,
    MalaysianRinggit = 6,
    HongKongDollar = 7,
}

export const BookmakerCode: Record<number, string> = {
    [Bookmaker.Sbo]: 'SBO',
    [Bookmaker.Ibc]: 'IBC',
    [Bookmaker.Sing]: 'SNG',
    [Bookmaker.Pinna]: 'PIN',
    [Bookmaker.Isn]: 'ISN',
    [Bookmaker.Betfair]: 'BF',
    [Bookmaker.Sportmonks]: 'SM',
    [Bookmaker.Sharpbet]: 'SB',
    [Bookmaker.Pinweb]: 'PinWeb',
    [Bookmaker.ThreeBet]: '3ET',
    [Bookmaker.Matchbook]: 'MB',
    [Bookmaker.Betdaq]: 'BQ',
};

export const BookmakerName: Record<number, string> = {
    [Bookmaker.Sbo]: 'SBO',
    [Bookmaker.Ibc]: 'IBC',
    [Bookmaker.Sing]: 'Singbet',
    [Bookmaker.Pinna]: 'Pinnacle',
    [Bookmaker.Isn]: 'ISN',
    [Bookmaker.Betfair]: 'Betfair',
    [Bookmaker.Sportmonks]: 'Sportmonks',
    [Bookmaker.Sharpbet]: 'Sharpbet',
    [Bookmaker.Pinweb]: 'PinWeb',
    [Bookmaker.ThreeBet]: '3et',
    [Bookmaker.Matchbook]: 'Matchbook',
    [Bookmaker.Betdaq]: 'Betdaq',
};

export const BookmakerRulesLink: Record<number, string> = {
    [Bookmaker.Sbo]: 'https://help.sbobet.com/article/sports-betting-rules-301.html',
    [Bookmaker.Ibc]: 'https://www.nova88.com/index_info.aspx?page=3&lang=en',
    [Bookmaker.Pinna]: 'https://www.ps3838.com/static/index.php/en/help/bettingrules#Soccer',
    [Bookmaker.Isn]: 'http://www.isn99.com/membersite-api/cms/rules/?locale=en_US#',
    [Bookmaker.Betfair]: 'https://www.betfair.com/en/aboutUs/Rules.and.Regulations/',
    [Bookmaker.Sharpbet]: 'https://sharpbet.com/page/bettingrules',
    [Bookmaker.ThreeBet]: 'https://www.3et.com',
    [Bookmaker.Matchbook]: 'https://www.matchbook.com/page/rules_and_regulations/sports-rules',
};

export const BookmakerTermsLink: Record<number, string> = {
    [Bookmaker.Ibc]: 'https://www.nova88.com/index_info.aspx?page=3&lang=en',
    [Bookmaker.Pinna]: 'https://www.ps3838.com/static/index.php/en/',
    [Bookmaker.Betfair]: 'https://www.betfair.com/en/aboutUs/Terms.and.Conditions/',
    [Bookmaker.ThreeBet]: 'https://www.3et.com',
    [Bookmaker.Matchbook]: 'https://www.matchbook.com/page/rules_and_regulations/terms-and-conditions',
};

/** Bookmaker site ids shown in tool-user `Position %` / `Position WL %` blocks (rows order from legacy admin). */
export const TOOL_USER_POSITION_SITE_IDS: number[] = [
    Bookmaker.Pinna,
    Bookmaker.Betfair,
    Bookmaker.Matchbook,
    Bookmaker.ThreeBet,
    Bookmaker.Sharpbet,
    Bookmaker.Ibc,
    Bookmaker.Sbo,
    Bookmaker.Betdaq,
];

/** Short uppercase labels (legacy admin) for tool-user `Position %` rows — they differ from the generic `BookmakerCode` map. */
export const ToolUserPositionSiteLabel: Record<number, string> = {
    [Bookmaker.Pinna]: 'PINNA',
    [Bookmaker.Betfair]: 'BETFAIR',
    [Bookmaker.Matchbook]: 'MB',
    [Bookmaker.ThreeBet]: '3et',
    [Bookmaker.Sharpbet]: 'SHARPBET',
    [Bookmaker.Ibc]: 'IBC',
    [Bookmaker.Sbo]: 'SBO',
    [Bookmaker.Betdaq]: 'BQ',
};

export const SbobetAllowedCustomLeagueIds: number[] = [
    71, 130, 88, 209, 83, 1354, 89, 1357, 1380, 1593, 2759, 2758, 66, 65, 165, 1364, 214, 58, 102, 92, 2760, 2566,
];
export const IbcbetAllowedLimitsCategoryIds: number[] = [1, 2, 3];

export enum NotificationType {
    Info = 1,
    Warning = 2,
    Error = 3,
    Notification = 4,
    Message = 5,
}

export enum Country {
    Brazil = 18,
}

export enum DballMarket {
    Live = 1,
    Today = 2,
    Early = 3,
}

export enum EventFeedType {
    Live = 1,
    Today = 2,
    Early = 3,
}

export enum Agent {
    Victor = 104,
}

export enum FeedWsResponseStatus {
    Ok = 0,
    VersionIncorrect = 1,
    FeedParamsIncorrect = 2,
    SubscribeIdIncorrect = 3,
    WaitingCorrectVersion = 4,
}

export enum League {
    Fantasy = 1491,
}

export enum StoreName {
    FeedLive = 'feedLive',
    FeedPregame = 'feedPregame',
    FeedBoard = 'board',
}

export enum Theme {
    Light = 'light',
    Dark = 'dark',
}

export enum OrderOddsType {
    Best = 1,
    Median = 2,
    Lowest = 3,
}

export enum SystemAlertStatusId {
    Success = 0,
    Warning = 1,
    Fail = 2,
}

export enum AlertStatusId {
    Success = 0,
    Fail = 1,
}

export enum EventName {
    PageReload = 'pageReload',
    PageResize = 'pageResize',
    BetsChanged = 'betsChanged',
    OrderChanged = 'orderChanged',
    OrderAdded = 'orderAdded',
    BrowserTabVisibilityChanged = 'browserTabVisibilityChanged',
    LanguageChanged = 'languageChanged',
    WebSocketUsers = 'webSocketUsers',
}

export enum OrderClosingCode {
    Successful = 0,
    Failed = 1,
    InProgress = 2,
}

export enum PregameStatusFilters {
    Today = 'today',
    NotStarted = 'not_started',
    Next1h = 'next1h',
    Next2h = 'next2h',
    Next4h = 'next4h',
}

export enum PregameGameStatus {
    Upcoming = 'upcoming',
    Live = 'live',
    Finished = 'finished',
    Undefined = 'undefined',
}
export const EarlyFeedFilterDateTimezone: string = 'Europe/London';
export const EarlyFeedStartNextDayHour: number = 4;

export const BOT_OPTIONS_MAP_REVERSE: Record<string, string> = {
    id: 'id',
    cr: 'created_at',
    up: 'updated_at',
    ch: 'changed_at',
    dl: 'deleted_at',
    st: 'suspended_till',
    uid: 'tool_user_id',
    nm: 'name',
    cd: 'code',
    ds: 'description',
    ia: 'is_active',
    fid: 'feed_id',
    ac: 'activated_at',
    dc: 'deactivated_at',
    sk: 'stake',
    ms: 'is_use_min_stake',
    sb: 'is_skip_betfair_only',
    tu: 'is_top_ups',
    pt: 'period_type_id',
    bt: 'bet_type_id',
    bs: 'bet_selection_id',
    br: 'bet_repetition_id',
    rc: 'live_red_card_id',
    gs: 'live_game_situation_id',
    lmf: 'live_minute_from',
    lmt: 'live_minute_to',
    ht: 'is_bet_half_time',
    ls: 'live_score',
    lof: 'live_odds_from',
    lot: 'live_odds_to',
    lhf: 'live_handicap_from',
    lht: 'live_handicap_to',
    lgf: 'live_goal_line_from',
    lgt: 'live_goal_line_to',
    lghf: 'live_goal_handicap_from',
    lght: 'live_goal_handicap_to',
    ssc: 'live_score_sum_condition',
    ssm: 'live_score_sum',
    lll: 'live_leading_losing',
    lat: 'live_attack_team_selection_id',
    laf: 'live_attack_from',
    lat2: 'live_attack_to',
    lda: 'live_dangerous_attack_team_selection_id',
    ldf: 'live_dangerous_attack_from',
    ldt: 'live_dangerous_attack_to',
    lst: 'live_shots_team_selection_id',
    lsf: 'live_shots_from',
    lst2: 'live_shots_to',
    lct: 'live_corners_team_selection_id',
    lcf: 'live_corners_from',
    lct2: 'live_corners_to',
    lpt: 'live_possession_team_selection_id',
    lpf: 'live_possession_from',
    lpt2: 'live_possession_to',
    lotg: 'live_shots_on_target_team_selection_id',
    ltof: 'live_shots_on_target_from',
    ltot: 'live_shots_on_target_to',
    ttaf: 'live_total_attack_from',
    ttat: 'live_total_attack_to',
    ttdf: 'live_total_dangerous_attack_from',
    ttdt: 'live_total_dangerous_attack_to',
    tsf: 'live_total_shots_from',
    tst: 'live_total_shots_to',
    tcf: 'live_total_corners_from',
    tct: 'live_total_corners_to',
    tsof: 'live_total_shots_on_target_from',
    tsot: 'live_total_shots_on_target_to',
    m1t: 'live_1x2_margin_perc_to',
    mht: 'live_handicap_margin_perc_to',
    mgt: 'live_goal_margin_perc_to',
    clg2: 'custom_league_gender',
    dbw: 'dball_jollywhere',
    dbf: 'dball_favorite_underdog',
    dbwf: 'dball_jolly_win_perc_from',
    dbwt: 'dball_jolly_win_perc_to',
    dbohf: 'dball_open_handicap_from',
    dboht: 'dball_open_handicap_to',
    dbogf: 'dball_open_goal_line_from',
    dbogt: 'dball_open_goal_line_to',
    dbchf: 'dball_close_handicap_from',
    dbcht: 'dball_close_handicap_to',
    dbcgf: 'dball_close_goal_line_from',
    dbcgt: 'dball_close_goal_line_to',
    sts: 'settings',
};

export const BOT_CONDITIONS_MAP_REVERSE: Record<string, string> = {
    mc: 'minute_condition',
    oc: 'odds_condition',
    sc: 'score_condition',
    sic: 'situation_condition',
    ssc: 'score_sum_condition',
    hc: 'handicap_condition',
    gc: 'goal_condition',
    ghc: 'goal_handicap_condition',
    rcc: 'live_red_card_condition',
    ac: 'attack_condition',
    dac: 'dangerous_attack_condition',
    shc: 'shots_condition',
    cc: 'corners_condition',
    stc: 'shots_on_target_condition',
    wmpc: 'wld_margin_perc_condition',
    hmpc: 'handicap_margin_perc_condition',
    gmpc: 'goal_margin_perc_condition',
    pc: 'possession_condition',
    tac: 'total_attack_condition',
    tdc: 'total_dangerous_attack_condition',
    tsc: 'total_shots_condition',
    tcc: 'total_corners_condition',
    tsot: 'total_shots_on_target_condition',
    grc: 'group_condition',
    gxc: 'group_exclude_condition',
    gdc: 'gender_condition',
    agc: 'age_condition',
    ctc: 'category_condition',
    lic: 'limits_condition',
    jwc: 'jollywhere_condition',
    ftc: 'favorite_team_condition',
    ohc: 'open_handicap_condition',
    ogc: 'open_goal_condition',
    chc: 'close_handicap_condition',
    cgc: 'close_goal_condition',
};

export enum WlTransactionType {
    NewBet = 1,
    AcceptBet = 2,
    FailedBet = 3,
    ChangeStatus = 4,
    UnsetBet = 5,
}

export enum WlTransactionOperation {
    Debit = 1,
    Credit = 2,
    Info = 3,
}

export enum WlTransactionStatus {
    NotProcessed = 1,
    Processed = 2,
    Failed = 3,
    ManualClosed = 4,
}

export enum TransferOperation {
    Deposit = 1,
    Withdrawal = 2,
}

export enum TransferStatus {
    Approved = 1,
    Pending = 2,
    Rejected = 3,
    Expired = 4,
}

export enum AuditAction {
    Add = 1,
    Update = 2,
    Delete = 3,
}

export enum MappingProblemType {
    TeamOpponentMismatch = 1,
    TeamsSwapped = 2,
    SameTeamOnBothSides = 3,
    LeagueMismatch = 4,
}

export enum MappingProblemStatus {
    Open = 1,
    Processing = 2,
    ResolvedManual = 3,
    ResolvedThirdParty = 4,
    ResolvedAutomatic = 5,
    AwaitingData = 6,
}

export enum MappingProblemSolutionStatus {
    Proposed = 1,
    Applied = 2,
}

export enum UserType {
    Root = 1,
    Admin = 2,
    Company = 3,
    Agent = 6,
    Player = 7,
    AgentView = 8,
    AgentPlatform = 9,
}

export enum BetDateType {
    PlacementLondon = 1,
    SettlementLondon = 2,
    PlacementGMT = 3,
    SettlementGMT = 4,
}

export enum BetSettlementType {
    New = 1,
    Update = 2,
}
